import { Component, ElementRef, OnInit, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import {
  DataStateChangeEventArgs,
  FilterSettingsModel,
  GridComponent,
  SelectionSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { GlobalComponent } from "src/app/global/global.component";
import { QPInfoService } from "./qp-info.service";
import { subscribeOn, takeUntil } from "rxjs/operators";
// import { ConfigurationService } from "src/app/configuration.service";
import { DatePipe } from "@angular/common";
import * as pbi from "powerbi-client";
import { ColumnChangeBO } from "../list/list.model";
// import { columnWidth } from "../icd10/icd10.model";
import { ClientRelationshipReportBo, QPfilter } from "./qp-info.modal";
import {
  ClientQpInfoBO,
  GetClientEmployeeRelationshipBO,
} from "../client-parent/client-parent.model";
import { HttpErrorResponse } from "@angular/common/http";
import { DateService } from "src/app/date.service";
import { IMyDpOptions } from "mydatepicker";
import { CommonApiService } from "src/app/commonapiservice";
import { Guid } from "@syncfusion/ej2/pdf-export";
import { EmployeeService } from "../employee/employee.service";
import { EnvironmentService } from "src/app/environment.service";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: "app-qp-info",
  templateUrl: "./qp-info.component.html",
  styleUrls: ["./qp-info.component.scss"],
})
export class QpInfoComponent implements OnInit {
  isQpMapSave: boolean = true;
  public formatOptions: object;
  QpEmployeeid: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  public QpInfoData: Observable<DataStateChangeEventArgs>;
  public QPClientMapping: Observable<DataStateChangeEventArgs>;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  // initialPage1:["10", "15", "20", "50", "100", "250"];
  clientids: any = [];
  QpClientEmployeeReportinitialPage: object;
  locationId: string = "00000000-0000-0000-0000-000000000000";
  isEnabledExcel: boolean = false;
  QpEmployeelist: any = [];
  configuration: any;
  serviceDropdown: any = [];
  withoutpaginationclientIds: any = [];
  filterLanguages: any = [];
  reportcontain: boolean = false;
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  reptitle: any = "";
  changeRelationshipList: any = [];
  QpRelationshipstatus: number = 0;
  QpList: any = [];
  QpMappingList: any = [];
  RelationshipTypeList: any = [];
  reassignEmployeeId: any;
  activeDate: any;
  public selectionOptions: SelectionSettingsModel;
  EmployeeDropdown: [{ Key: string; Value: string }];
  @ViewChild("gridQpClientEmployeeReport")
  public gridQpClientEmployeeReport: GridComponent;
  @ViewChild("gridQpClientMapping") public gridQpClientMapping: GridComponent;
  selectedCheckList: any = [];
  saveClientEmployee: any = new GetClientEmployeeRelationshipBO();
  ClientEmployee: GetClientEmployeeRelationshipBO[] = [];
  QpMappingInfoBo: ClientQpInfoBO = new ClientQpInfoBO();
  QpInfoClientRelationshipReportBo: ClientRelationshipReportBo =
    new ClientRelationshipReportBo();
  ClientStatus: [{ id: Guid; lovName: string }];
  QpStatusDropdown: any = [];
  QpDropdata: string[] = [];
  height: string = "200px";
  PcaTypeList: any = [];
  TypeofClient: any = [];
  QPFilter: QPfilter = new QPfilter();
  ColumnArrayData: any[];
  ColumnArrayQPReportData: any[];
  id: string = "00000000-0000-0000-0000-000000000000";
  clientid: any;
  compareStatusLid: any;
  statusLid: any;
  employeeId: any;
  LanguageList: any = [];
  clienttypeLid: any;
  // pCATypeLid: any;
  arraycol: any = [];
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  type: string;
  ClientDropdown: any;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ListEmployeeId: any;
  ListClientId: any;
  ClientMapping:boolean = true;
   @Input() preSelectedClientId: string = null;
  @Input() openedFromClientPage: boolean = false;
    private shouldAutoOpenMapping: boolean = false;
  EmployeeDropDown: any = [];
  saveAuthErr: string = ''
  @Output() employeeMappingSaved = new EventEmitter<void>();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  constructor(
    public dateService: DateService,
    public datepipe: DatePipe,
    public CommonAPI: CommonApiService,
    private employeeService: EmployeeService,
    public environmentService: EnvironmentService,
    private router: Router,
    public global: GlobalComponent,
    public toasterService: ToastrService,
    public qpInfoService: QPInfoService,
    private route: ActivatedRoute,
  ) {
    this.QpInfoData = qpInfoService;
    this.QPClientMapping = CommonAPI;
    this.configuration = this.environmentService.getEnvironmentsConfiguration();
  }
  ngOnInit(): void {
    if (this.openedFromClientPage && this.preSelectedClientId) {
      this.ListClientId = this.preSelectedClientId;
      this.shouldAutoOpenMapping = true;
      this.ClientMapping =false;
      // document.getElementById('QPopen').click();
      
     
      console.log('Pre-selected Client ID:', this.preSelectedClientId);
        this.getStatusType();
      // Apply filter to show only this client's mappings
      //this.ApplyFilter();
    }


    if (
      this.global.globalAgencyId == null ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000"
    ) {
      return;
    }
    this.filterOptions = { type: "Menu" };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    let QpMappingPage = null;
    let QpInfoPage = null;
    if (this.global.selectedLocationDropdown == null || this.global.selectedLocationDropdown == undefined || this.global.selectedLocationDropdown == '') {
      this.locationId = null;

    }
    else {
      this.locationId = this.global.selectedLocationDropdown;
    }
    if (
      this.global.globalColumn != null &&
      this.global.globalColumn != undefined &&
      this.global.globalColumn != ""
    ) {
      QpMappingPage = JSON.parse(this.global.globalColumn.column)[0].Qp
        .Pagesize;

      QpInfoPage = JSON.parse(this.global.globalColumn.column)[0].QPInfoReport
        .Pagesize;
      this.QpInfoClientRelationshipReportBo.pageitem = QpInfoPage;
      this.QpMappingInfoBo.pageitem = QpMappingPage;
    } else {
      QpMappingPage = 10;
      QpInfoPage = 10;
    }
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: QpMappingPage,
      pageSize: QpMappingPage,
      pageSizes: this.pageSizes,
    };
    this.QpClientEmployeeReportinitialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: QpInfoPage,
      pageSize: QpInfoPage,
      pageSizes: this.pageSizes,
    };
    this.selectionOptions = {
      checkboxOnly: true,
    };
    this.getQpInfoClientRelationshipFilter();
    this.getRelationship();
    this.getEmployeeDropdown();
    // this.getClient();
    this.getLanguageList();
    this.getClientDropdown();
    this.getClientTypeLid();

    this.route.queryParams.subscribe(params => {
    if (params['openMapping'] === 'true') {
      this.clientid = params['clientId'];
      this.isQpMapSave = true;
      this.getStatusType();
      
      // Small delay to ensure modal is ready
      setTimeout(() => {
        document.getElementById("QPinfo")?.click();
      }, 500);
    }
  });
  }
   ngAfterViewInit() {
  if (this.shouldAutoOpenMapping) {
    setTimeout(() => {
      console.log('Attempting to open modal...');
      
      // Set clientid for filtering the grid
      if (this.openedFromClientPage && this.preSelectedClientId) {
        this.clientid = this.preSelectedClientId;
        console.log('Pre-filled client for grid:', this.preSelectedClientId);
      }
      
      // Load the grid with filtered data
      this.getQpClientMappingFilter();
      
      // Click QPopen to show the first modal (but content will be hidden)
      const modalTrigger = document.getElementById("QPopen");
      if (modalTrigger) {
        console.log('Found QPopen button, clicking...');
        modalTrigger.click();
      } else {
        console.error('QPopen button not found!');
      }
      
      // Wait for modal to open, then open the Create New Mapping modal
      setTimeout(() => {
        this.openCreateMappingModal();
      }, 500);
      
    }, 1200); // Increased delay to ensure ClientStatus and ClientDropdown are loaded
  }
}

// NEW METHOD: Open the Create New Mapping modal with pre-filled client
openCreateMappingModal() {
  // Initialize the save object
  this.saveClientEmployee = new GetClientEmployeeRelationshipBO();
  
  // Set status
  if (this.ClientStatus && this.ClientStatus.length > 0) {
    const activeStatus = this.ClientStatus.filter((e) => e.lovName == "Active")[0];
    this.saveClientEmployee.statusLid = activeStatus?.id;
  }
  
  // PRE-FILL CLIENT - This is the key part!
  if (this.openedFromClientPage && this.preSelectedClientId) {
    this.saveClientEmployee.clientId = this.preSelectedClientId;
    console.log('Pre-filled client in form:', this.preSelectedClientId);
    console.log('ClientDropdown available:', this.ClientDropdown?.length);
    
    // Verify client exists in dropdown
    if (this.ClientDropdown) {
      const foundClient = this.ClientDropdown.find(c => c.Key === this.preSelectedClientId);
      console.log('Client found in dropdown:', foundClient);
    }
  }
  

}
  //.................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridQpClientEmployeeReport.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].QPInfoReport.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].QPInfoReport.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (
            this.arraycol[0].QPInfoReport.ShowColumns.length != count1 ||
            this.arraycol[0].QPInfoReport.HideColumns.length != count
          ) {
            this.arraycol[0].QPInfoReport.ShowColumns = showarr;
            this.arraycol[0].QPInfoReport.HideColumns = hidearr;
            this.arraycol[0].QPInfoReport.Pagesize =
              this.gridQpClientEmployeeReport.pagerModule.pagerObj.pageSize;
            // this.SaveColumnwidth();
          }
        }
      }
    }
    this.QpInfoClientRelationshipReportBo.currentpageno =
      this.gridQpClientEmployeeReport.pagerModule.pagerObj.currentPage;
    this.QpInfoClientRelationshipReportBo.pageitem =
      this.gridQpClientEmployeeReport.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.QpInfoClientRelationshipReportBo.type = args.columnType;
    }
  }
  //.................................................dataStateChange........................................................
  public dataStateChange(state): void {
    let type = state.action.requestType.toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.QpInfoClientRelationshipReportBo.orderColumn =
          state.sorted[0].name;
        this.QpInfoClientRelationshipReportBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.QpInfoClientRelationshipReportBo.type == "number") {
        this.QpInfoClientRelationshipReportBo.value =
          state.action.currentFilterObject.value.toString();
        this.QpInfoClientRelationshipReportBo.field =
          state.action.currentFilterObject.field;
      }
      if (this.QpInfoClientRelationshipReportBo.type == "date") {
        this.QpInfoClientRelationshipReportBo.value = new Date(
          new Date(
            state.action.currentFilterObject.value
          ).toLocaleDateString() +
          " " +
          "00:00:00" +
          " " +
          "GMT"
        )
          .toISOString()
          .replace("Z", "");
        this.QpInfoClientRelationshipReportBo.field =
          state.action.currentFilterObject.field;
      } else if (this.QpInfoClientRelationshipReportBo.type == "number") {
        this.QpInfoClientRelationshipReportBo.value =
          state.action.currentFilterObject.value.toString();
        this.QpInfoClientRelationshipReportBo.field =
          state.action.currentFilterObject.field;
      } else {
        this.QpInfoClientRelationshipReportBo.value =
          state.action.currentFilterObject.value;
        this.QpInfoClientRelationshipReportBo.field =
          state.action.currentFilterObject.field;
      }
      this.QpInfoClientRelationshipReportBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.QpInfoClientRelationshipReportBo.operator =
        state.action.currentFilterObject.operator;
    } else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.QpInfoClientRelationshipReportBo.field = "clientName";
        this.QpInfoClientRelationshipReportBo.matchCase = false;
        this.QpInfoClientRelationshipReportBo.operator = "contains";
        this.QpInfoClientRelationshipReportBo.value = "";
        this.QpInfoClientRelationshipReportBo.type = "string";
      }
    }
    this.ApplyFilter();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].QPInfoReport.Pagesize != state.take) {
          this.arraycol[0].QPInfoReport.Pagesize = state.take;
          // this.SaveColumnwidth();
        }
      }
    }
  }
  //.................................................getStatusType........................................................
  getQpInfoClientRelationshipFilter() {
  this.QpInfoClientRelationshipReportBo.clientTypeLid = (this.clienttypeLid ?? "") == "" ? null : (this.clienttypeLid);
  this.QpInfoClientRelationshipReportBo.locationID = this.locationId;
  this.QpInfoClientRelationshipReportBo.languageTypeLid = this.filterLanguages;
  
  // PRIORITY: Check if opened from client page
  if (this.openedFromClientPage && this.preSelectedClientId) {
    this.QpInfoClientRelationshipReportBo.clientId = this.preSelectedClientId;
  }
  else if (this.ListClientId != null && this.ListClientId != undefined && this.ListClientId != '') {
    this.QpInfoClientRelationshipReportBo.clientId = this.ListClientId;
  }
  else {
    this.QpInfoClientRelationshipReportBo.clientId = "00000000-0000-0000-0000-000000000000";
    this.ListClientId = null;
  }
  
  if (this.ListEmployeeId != null && this.ListEmployeeId != undefined && this.ListEmployeeId != '') {
    this.QpInfoClientRelationshipReportBo.employeeId = this.ListEmployeeId;
  }
  else {
    this.QpInfoClientRelationshipReportBo.employeeId = "00000000-0000-0000-0000-000000000000";
    this.ListEmployeeId = null;
  }

  this.qpInfoService.outputValuesClientRelationshipReport(
    this.QpInfoClientRelationshipReportBo
  );
  
  let count = 0;
  this.QpInfoData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.QpList = data.result;
    this.withoutpaginationclientIds = data.clientIds;
    if (data.result.length > 15) {
      this.gridQpClientEmployeeReport.height = "500";
    } else {
      this.gridQpClientEmployeeReport.height = "auto";
    }
    if (data != null && data.result.length > 0) {
      this.isEnabledExcel = true;
    } else {
      this.isEnabledExcel = false;
    }
    count = count + 1;
    if (data != null && data != undefined && count == 1) {
      // this.getColumnwidth();
    }
  });
}
  //.................................................onResize........................................................
  onResizeClientEmployeeReport(args) {
    if (this.ColumnArrayQPReportData != null && this.ColumnArrayQPReportData != undefined) {
      const column = this.gridQpClientEmployeeReport.getColumnByField(
        args.column.field
      );
      column.width = args.column.width;
      this.ColumnArrayQPReportData.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  //.................................................ApplyFilter........................................................
 ApplyFilter() {
  this.QpInfoClientRelationshipReportBo.clientTypeLid = (this.clienttypeLid ?? "") == "" ? null : (this.clienttypeLid);
  this.QpInfoClientRelationshipReportBo.locationID = this.locationId;
  this.QpInfoClientRelationshipReportBo.languageTypeLid = this.filterLanguages;
  
  // PRIORITY: Check if opened from client page
  if (this.openedFromClientPage && this.preSelectedClientId) {
    this.QpInfoClientRelationshipReportBo.clientId = this.preSelectedClientId;
  }
  else if (this.ListClientId != null && this.ListClientId != undefined && this.ListClientId != '') {
    this.QpInfoClientRelationshipReportBo.clientId = this.ListClientId;
  }
  else {
    this.QpInfoClientRelationshipReportBo.clientId = "00000000-0000-0000-0000-000000000000";
    this.ListClientId = null;
  }
  
  if (this.ListEmployeeId != null && this.ListEmployeeId != undefined && this.ListEmployeeId != '') {
    this.QpInfoClientRelationshipReportBo.employeeId = this.ListEmployeeId;
  }
  else {
    this.QpInfoClientRelationshipReportBo.employeeId = "00000000-0000-0000-0000-000000000000";
    this.ListEmployeeId = null;
  }
  
  this.getQpInfoClientRelationshipFilter();
}
  //.................................................RefreshFilter........................................................
  ClearFilter() {
    this.clienttypeLid = null;
    // this.pCATypeLid = null;
    this.ListEmployeeId = null;
    this.ListClientId = null;
    this.QpInfoClientRelationshipReportBo = new ClientRelationshipReportBo()
    this.filterLanguages = [];
    let QpInfoPage = JSON.parse(this.global.globalColumn.column)[0].QPInfoReport
      .Pagesize;
    this.QpInfoClientRelationshipReportBo.pageitem = QpInfoPage;
    this.gridQpClientEmployeeReport.clearFiltering();
    this.gridQpClientEmployeeReport.clearSorting();
    this.gridQpClientEmployeeReport.dataSource = []

  }
  //.................................................getQpEmployee........................................................
  getQpEmployee() {
    this.QpEmployeeid = null;
    let params = new URLSearchParams();
    // params.append("LocationId", this.locationId);
    let url = "api/Employee/getAllEmployeesForDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.QpEmployeelist = data;
      });
  }
  //.................................................generateQpReport........................................................
  generateQpReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Employee Mapping Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("QPReportopen").click();
      document.getElementById("openPowerBiReport").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.EmployeeClientMapReportId +
        "&rp:empid=" +
        this.QpEmployeeid +
        "&rp:statuslid=" +
        '' +
        "&rp:statuslidname=" +
        (this.QpRelationshipstatus == 1
          ? "ACTIVE"
          : this.QpRelationshipstatus == 2
            ? "INACTIVE"
            : "ALL") +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        (this.locationId != null &&
          this.locationId != undefined &&
          this.locationId != ""
          ? this.locationId
          : '') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.EmployeeClientMapReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  //.................................................MovetoEmployeeParent........................................................
  MovetoEmployeeParent() {
    this.router.navigateByUrl("/Client");
  }

  //.................................................getStatusType........................................................
  getStatusType() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    // params.append("userId", this.global.userID);
    let url = 'api/LOV/getLovDropDown?';
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: [{ id: Guid; lovName: string }]) => {
          this.ClientStatus = JSON.parse(JSON.stringify(data));
          this.QpDropdata = data.map((e) => e.lovName);
          this.QpStatusDropdown = JSON.parse(JSON.stringify(data));
          this.ClientStatus.push({ id: Guid, lovName: "All" });
          this.statusLid = this.ClientStatus.filter(
            (st) => st.lovName == "Active"
          )[0].id;
          this.QpMappingInfoBo.statusLid = this.ClientStatus.filter(
            (st) => st.lovName == "Active"
          )[0].id;

          let activeStatusLid = this.ClientStatus?.filter(
            (st) => st.lovName == "Active"
          )[0].id;
          let inactiveStatusLid = this.ClientStatus?.filter(
            (st) => st.lovName == "InActive"
          )[0].id;
          this.compareStatusLid = Math.abs(
            activeStatusLid.toString().length - inactiveStatusLid.toString().length
          );

          this.getClientDropdown();
          this.getEmployeeDropdown();
          this.getQpClientMappingFilter();


        },
        (err: any) => {
          this.toasterService.error(err);
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }

  //.................................................newmap........................................................
newmap() {
  this.saveClientEmployee = new GetClientEmployeeRelationshipBO();
  
  // Set status
  if (this.ClientStatus && this.ClientStatus.length > 0) {
    const activeStatus = this.ClientStatus.filter((e) => e.lovName == "Active")[0];
    this.saveClientEmployee.statusLid = activeStatus?.id;
  }
  
  // IMPORTANT: DON'T override client if already opened from client page
  if (!this.openedFromClientPage) {
    // Normal behavior - client dropdown is empty
    this.saveClientEmployee.clientId = null;
  } else {
    // Opened from client page - keep the pre-selected client
    this.saveClientEmployee.clientId = this.preSelectedClientId;
  }
  
  document.getElementById("QPAddopen").click();
}
  //.................................................editmap........................................................
  editmap(data) {
    this.saveClientEmployee = JSON.parse(JSON.stringify(data));
    this.saveClientEmployee.clientId =
      this.saveClientEmployee.clientId.toString();
    this.saveClientEmployee.employeeId =
      this.saveClientEmployee.employeeId.toString();
    this.saveClientEmployee.statusLid =
      this.saveClientEmployee.statusLid.toString();

    if (this.saveClientEmployee.clientId != "00000000-0000-0000-0000-000000000000") {
      // this.getMappedClientServiceData(this.saveClientEmployee.clientId,"EditEvent");
    }
    this.saveClientEmployee.activeDate = this.datepipe.transform(
      this.saveClientEmployee.activeDate,
      "MM/dd/yyyy"
    );
    this.saveClientEmployee.inActiveDate = this.datepipe.transform(
      this.saveClientEmployee?.inActiveDate,
      "MM/dd/yyyy"
    );
  }

  //.................................................qpClose........................................................
  qpClose() {
    document.getElementById("QPAddopen").click();
  }
  //.................................................onResizeQp........................................................
  onResizeQp(args) {

    if (this.ColumnArrayData != null && this.ColumnArrayData != undefined) {
      const column = this.gridQpClientMapping.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArrayData.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  //.................................................onComplete........................................................
  public onComplete(args) {
    this.QpMappingInfoBo.currentpageno =
      this.gridQpClientMapping.pagerModule.pagerObj.currentPage;
    this.QpMappingInfoBo.pageitem =
      this.gridQpClientMapping.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.QpMappingInfoBo.type = args.columnType;
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridQpClientMapping.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Qp.ShowColumns.forEach((old) => {
          showarr.forEach((element) => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Qp.HideColumns.forEach((old) => {
          hidearr.forEach((element) => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (
          this.arraycol[0].Qp.ShowColumns.length != count1 ||
          this.arraycol[0].Qp.HideColumns.length != count
        ) {
          this.arraycol[0].Qp.ShowColumns = showarr;
          this.arraycol[0].Qp.HideColumns = hidearr;
          // this.SaveColumnwidth();
        }
      }
    }
  }
  //.................................................QPDataChange........................................................
  public QPDataChange(state): void {
    this.type = state.action.requestType.toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.QpMappingInfoBo.orderColumn = state.sorted[0].name;
        this.QpMappingInfoBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.QpMappingInfoBo.field = state.action.currentFilterObject.field;
      this.QpMappingInfoBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.QpMappingInfoBo.operator = state.action.currentFilterObject.operator;
      this.QpMappingInfoBo.value = state.action.currentFilterObject.value;
    } else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.QpMappingInfoBo.field = "clientName";
        this.QpMappingInfoBo.matchCase = false;
        this.QpMappingInfoBo.operator = "startswith";
        this.QpMappingInfoBo.value = "";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Qp.Pagesize != state.take) {
          this.arraycol[0].Qp.Pagesize = state.take;
          // this.SaveColumnwidth();
        }
      }
    }

    this.getQpClientMappingFilter();
  }
  //.................................................showColumn........................................................
  showColumn() {
    this.gridQpClientMapping.columnChooserModule.openColumnChooser(200, 50);
  }
  //.................................................showColumn........................................................
  showQpClientEmployeeColumn() {
    this.gridQpClientEmployeeReport.columnChooserModule.openColumnChooser(
      200,
      50
    );
  }
  //.................................................getClientDropDown........................................................
  getClientDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Client/clientDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {

          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.ClientDropdown = data;
        console.log(this.ClientDropdown, "  this.ClientDropdown ")

      });
  }
  //.................................................saveClientEmployeedata........................................................
  saveClientEmployeedata() {
    let val = JSON.parse(JSON.stringify(this.saveClientEmployee));
    val.clientId = (val?.clientId?.toString());
    val.employeeId = (val?.employeeId?.toString());
    val.statusLid = (val?.statusLid?.toString());
    // val.clientServiceId = val.clientServiceId == null || val.clientServiceId == undefined ? [] : val.clientServiceId;
    val.activeDate =
      val.activeDate == undefined ||
        val.activeDate == "" ||
        val.activeDate == null
        ? this.global.getDateTimeString(new Date())
        : this.global.getDateTimeString(val.activeDate);
    val.inActiveDate =
      val.inActiveDate != undefined &&
        val.inActiveDate != "" &&
        val.inActiveDate != null
        ? this.global.getDateTimeString(val.inActiveDate)
        : null;

    val.relationshipTypeLid =
      val.relationshipTypeLid != null && val.relationshipTypeLid != undefined && val.relationshipTypeLid != '' ? (val.relationshipTypeLid.toString()) : null;
    let url = "api/EmployeeClientMapping/SaveEmployeeClientMapping";
    this.CommonAPI
      .saveorUpdateFunctionwithResponseTypeJson(val, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          if (val.id == "00000000-0000-0000-0000-000000000000") {
            this.toasterService.success("Qp saved successfully!");
          }
          else {
            this.toasterService.success("Qp updated successfully!");
          }
          this.QPFilter = new QPfilter();
          this.getQpClientMappingFilter();
          document.getElementById("QPAddopen").click();
          this.saveClientEmployee = new GetClientEmployeeRelationshipBO();
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        },
        (err: any) => {
          this.toasterService.error(err, "error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  //.................................................getQpClientMappingFilter........................................................
  getQpClientMappingFilter() {
    // Only assign values to QpMappingInfoBo if the values are not null or undefined
    this.QpMappingInfoBo.clientId = this.clientid ?? undefined;
    this.QpMappingInfoBo.employeeId = this.employeeId ?? undefined;
    this.QpMappingInfoBo.statusLid = this.statusLid ?? undefined;
    this.QpMappingInfoBo.LocationID = this.global.globalLocationId ?? undefined;
    if(this.QpMappingInfoBo.LocationID == '' || this.QpMappingInfoBo.LocationID == undefined)
    {
      this.QpMappingInfoBo.LocationID = null;
    }
    // Define responseData structure
    let responseData = {
      result: "result",
      count: "count",
    };

    // Define the API URL
    let url = "api/EmployeeClientMapping/getEmployeeClientMapping";

    // Call the API with the mapping info
    this.CommonAPI.outputValues(url, this.QpMappingInfoBo, responseData, "");

    // Subscribe to the response data
    this.QPClientMapping.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        // Assign the result data to QpMappingList
        this.QpMappingList = data.result;

        // Adjust grid height based on the result length
        if (data.result.length > 15) {
          this.gridQpClientMapping.height = "500";
        } else {
          this.gridQpClientMapping.height = "auto";
        }
      }
    );
  }


  //.................................................checkboxSelection........................................................
  checkboxSelection(parameters) {
    this.selectedCheckList = [];
    if (
      parameters.checked &&
      parameters.target.classList.contains("e-checkselectall")
    ) {
      let MultipleRows: any = this.gridQpClientMapping.getSelectedRecords();
      this.selectedCheckList = MultipleRows.filter(
        (C) => C.clientId != "00000000-0000-0000-0000-000000000000" && C.clientId != null && C.clientId != ""
      ).map((t) => t);
    } else if (parameters.target.classList.contains("e-checkselect")) {
      let SingleRows: any = this.gridQpClientMapping.getSelectedRecords();
      this.selectedCheckList = SingleRows.filter(
        (C) => C.clientId != "00000000-0000-0000-0000-000000000000" && C.clientId != null && C.clientId != ""
      ).map((t) => t);
    }
  }
  //.................................................changeRelationshipStatus........................................................
  changeRelationshipStatus() {

    this.changeRelationshipList = [];
    this.selectedCheckList.forEach((element) => {
      let object = {
        id: element.id,
        // activeDate: this.global.getDateTimeString(new Date()),
        // statusLid:
        // element.statusName == "Active"
        // ? element.statusLid + this.compareStatusLid
        // : element.statusLid - this.compareStatusLid,
      };
      this.changeRelationshipList.push(object);
    });
    let url = "api/EmployeeClientMapping/ChangeEmployeeClientMappingStatus";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(this.changeRelationshipList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.selectedCheckList = [];
          this.changeRelationshipList = [];
          this.getQpClientMappingFilter();
        },
        (err: any) => {
          this.toasterService.error(err, "Error");
        }
      );
  }
  //.................................................reassignEmployeeClientRelationship........................................................
  reassignEmployeeClientRelationship() {
    let reassignRelationshipList = [];
    this.selectedCheckList.forEach((element) => {
      let object = {
        id: (element.id.toString()),
        clientId: (element.clientId.toString()),
        employeeId: (this.reassignEmployeeId.toString()),
        // living: false,
        activeDate: this.global.getDateTimeString(
          this.activeDate
        ),
        // clientServiceId: [],
        // statusLid: (element.statusLid.toString()),
        // statusName: element.statusName,
      };
      reassignRelationshipList.push(object);
    });
    let url = "api/EmployeeClientMapping/ReassignEmployeeClientMapping";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(reassignRelationshipList, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.selectedCheckList = [];

          this.changeRelationshipList = [];
          this.reassignClose();
          this.getQpClientMappingFilter();
        },
        (err: any) => {
          this.toasterService.error(err, "Error");
        }
      );
  }
  //.................................................reassignClose........................................................
  reassignClose() {
    this.reassignEmployeeId = null;
    this.activeDate = "";
    document.getElementById("openReassign").click();
  }
  //.................................................getLanguageList........................................................
  getLanguageList() {
    let url = "api/Language/GetLanguageList";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson("", url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.LanguageList = data;
        },
        (err: any) => {
          this.toasterService.error(err);
        }
      );
  }
  //.................................................DateFormat........................................................
  DateFormat(event, type, name) {
    console.log(name, "name")
    if (type == "inputChanged") {
      if (name == "activeDate") {
        let val = this.dateService.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateService.inputFeildchange(event);

          this.activeDate = val1;
        }
      }
      if (name == "ActiveDate") {
        let val = this.dateService.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateService.inputFeildchange(event);

          this.saveClientEmployee.activeDate = val1;
        }
      }
      if (name == "InActiveDate") {
        let val = this.dateService.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateService.inputFeildchange(event);

          this.saveClientEmployee.inActiveDate = val1;
        }
      }
    }
    if (type == "dateChanged") {
      if (name == "activeDate") {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateService.Datechange(event);

          this.activeDate = val1;
        }
      }
      if (name == "ActiveDate") {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateService.Datechange(event);

          this.saveClientEmployee.activeDate = val1;
        }
      }
      if (name == "InActiveDate") {
        let val = this.dateService.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateService.Datechange(event);

          this.saveClientEmployee.inActiveDate = val1;
        }
      }

    }
  }

  //.................................................generateQpReport........................................................
  generateExcelReport(page) {
    this.clientids = [];
    if (page == "Current") {
      this.QpList.forEach((element) => {
        this.clientids.push(element.clientId);
      });
    } else if (page == "all") {
      this.clientids = this.withoutpaginationclientIds;
    }
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Employee Mapping Info";
    // let value =
    //   this.QpInfoClientRelationshipReportBo.value != null && this.QpInfoClientRelationshipReportBo.value!=undefined && this.QpInfoClientRelationshipReportBo.value!=""
    //     ? 
    //     : null;


    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("exportaspdforexcel").click();
      document.getElementById("openPowerBiReport").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.EmployeeClientMapExcelReportId +
        "&rp:userid=" +
        (this.global.userID != null &&
          this.global.userID != undefined &&
          this.global.userID != ''
          ? this.global.userID
          : '') +

        "&rp:languageidist=" + "{" + ((this.filterLanguages.length == 0 || this.filterLanguages == null) ? '' : this.filterLanguages) + "}" +
        "&rp:pcatypelid=" +
        '' +
        "&rp:clienttylelid=" +
        (this.clienttypeLid != null ? (this.clienttypeLid) : '') +
        "&rp:clientid=" +
        (this.ListClientId != null ? (this.ListClientId) : '') +
        "&rp:qpemployeeid=" +
        (this.ListEmployeeId != null ? (this.ListEmployeeId) : '') +
        "&rp:field=" +
        this.QpInfoClientRelationshipReportBo.field +
        "&rp:val=" +
        this.QpInfoClientRelationshipReportBo.value +
        "&rp:printpages=" +
        page +
        "&rp:operators=" +
        this.QpInfoClientRelationshipReportBo.operator +
        "&rp:pagecount=" +
        this.QpInfoClientRelationshipReportBo.currentpageno +
        "&rp:itemsperpage=" +
        this.QpInfoClientRelationshipReportBo.pageitem +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        (this.locationId != null &&
          this.locationId != undefined &&
          this.locationId != ""
          ? (this.locationId)
          : '') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.EmployeeClientMapExcelReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  //.................................................closePowerBimodal........................................................
  closePowerBimodal() {
    document.getElementById("openPowerBiReport").click();
    this.reportcontain = false;
  }
  //.................................................getMappedClientServiceData........................................................
  // getMappedClientServiceData(clientId, EventType) {
  //   if (clientId != "00000000-0000-0000-0000-000000000000" && clientId != null && clientId != undefined) {
  //     let params = new URLSearchParams();
  //     params.append("clientId", clientId.toString());
  //     let url = "api/ClientServiceActivity/getMappedClientServiceData?"
  //     this.CommonAPI
  //       .GetFunctionwithResponseTypeJson(params, url)
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe(
  //         (data: any) => {
  //           if (EventType == "ChangeEvent") {
  //             this.saveClientEmployee.clientServiceId = null;
  //           }
  //           this.serviceDropdown = data;
  //         },
  //         (err: any) => {
  //           this.toasterService.error(err);
  //           setTimeout(() => {
  //             this.toasterService.clear();
  //           }, 8000);
  //         }
  //       );
  //   } else {
  //     this.serviceDropdown = [];
  //   }
  // }
  //.................................................getPCATypeLid........................................................
  // getPCATypeLid() {
  //   let urlstatus = "api/LOV/getLovDropDown?"
  //   let paramsstatus = new URLSearchParams();
  //   paramsstatus.append("Code", "PCATYPE");
  //   this.CommonAPI.getDropDownList("PCATYPE", paramsstatus, urlstatus, "LovDropDown").then(
  //     (data: any) => {
  //       this.PcaTypeList = data;
  //     },
  //     (err: any) => {
  //       this.toasterService.error(err);
  //       setTimeout(() => {
  //         this.toasterService.clear();
  //       }, 8000);
  //     }
  //   );
  // }
  //.................................................getClientTypeLid........................................................
  getClientTypeLid() {
    let urlstatus = "api/LOV/getLovDropDown?"
    let paramsstatus = new URLSearchParams();
    paramsstatus.append("ListCode", "CLIENTTYPE");
    this.CommonAPI.getDropDownList("CLIENTTYPE", paramsstatus, urlstatus, "LovDropDown").then((data: any) => {
      this.TypeofClient = data;
    },
      (err: any) => {
        this.toasterService.error(err);
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);
      }
    )
  }
  //.................................................refreshToGetDropDownValues........................................................
  refreshToGetDropDownValues(ListCode: string) {
    let urlstatus = "api/LOV/getLovDropDown?"
    let paramsstatus = new URLSearchParams();
    paramsstatus.append("Code", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, paramsstatus, urlstatus, "LovDropDown").then((data: any) => {
      // if (ListCode == "PCATYPE") {
      //   this.PcaTypeList = data;
      //   this.PcaTypeList.forEach((element) => {
      //     element.Key = element.Key.toString();
      //   });
      // }
      if (ListCode == 'CLIENTTYPE') {
        this.TypeofClient = data;
      }
      if (ListCode == 'RELATIONSHIP') {
        this.RelationshipTypeList = data;
      }
    });
  }
  clearQpClientMappingFilter() {
    this.clientid = null;
    this.employeeId = null;
      this.employeeMappingSaved.emit();
  }


  //.................................getClient....................................................................
  // getClient(): Observable<any> {
  //   let url = "api/Client/GetClientListbyTd?"
  //   return this.http.get<any>(url, { observe: 'response' }).pipe(
  //     map(data => data.body),
  //     catchError(this.errorService.handleError)
  //   )
  // }
  // getClient() {
  //   let params = new URLSearchParams();

    // params.append("LocationId", this.locationId);
  //   let url = "api/Client/GetClientListbyTd?"
  //   this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.ClientDropdown = data;
  //   });
  // }

  //......................................getEmployeeDropDown.........................................................
  getEmployeeDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Employee/employeeDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EmployeeDropdown = data;
      });
  }
  checkInvalidDate() {
    if (new Date(this.saveClientEmployee?.activeDate).getTime() > new Date(this.saveClientEmployee?.inActiveDate).getTime()) {
      this.saveAuthErr = "InActive date must be greater than Active date";
      this.saveClientEmployee.inActiveDate = ''
      setTimeout(() => {
        this.saveAuthErr = ''
      }, 2000);
    }
    else {
      this.saveAuthErr = ''
      this.saveClientEmployeedata();
    }
  }

  changeStatus() {
    let status = this.QpStatusDropdown.find(p=>p.id == this.saveClientEmployee.statusLid)?.lovCode;

    if (status.toLowerCase() != 'inactive') {
      this.saveClientEmployee.inActiveDate = null
    }
  }

  //.................................................getRelationship........................................................
  getRelationship() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "RELATIONSHIP");
    this.CommonAPI.getDropDownList('RELATIONSHIP', params, url, "LovDropDown").then((data) => {
      this.RelationshipTypeList = data;
      console.log(this.RelationshipTypeList)
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }
closeQpInfoModal() {
  const modalElement = document.getElementById('QPinfo');
  if (modalElement) {
    const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
    if (modal) {
      modal.hide();
    }
  }
}
  //.................................................ngOnDestroy........................................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
